import { load } from 'cheerio';

/**
 * Removes all class attributes from an HTML string.
 *
 * @param {string} html - The raw HTML content.
 * @returns {string} - The HTML content with class attributes removed.
 */
export function removeClasses(html: string): string {
  // Wrap the HTML content in a container element with a unique ID.
  const $ = load(`<div id="cheerio-temp-wrapper">${html}</div>`);

  // Remove class attributes from all elements within the container.
  $('#cheerio-temp-wrapper').find('[class]').removeAttr('class');

  // Return only the inner HTML of the container.
  return $('#cheerio-temp-wrapper').html() || '';
}
